
declare global {
  interface Window {
    gapi: any
  }
}

import { ExternalResponse, LoginResultSessionVM, LoginVM, Role } from '@/models'
import { Component, Vue } from 'vue-property-decorator'
import { login, loginWithGoogle } from '@/components/admin/users/users.service'
import ForgotPasswordCard from '@/views/Auth/ForgotPasswordCard.vue'
import { namespace } from 'vuex-class'
import GoogleSignInButton from 'vue-google-signin-button-directive'
import { AxiosResponse } from 'axios'
import {
  getDoctorInsurances,
  getUserInsurances
} from '@/components/doctors/doctors.service'

const AppModule = namespace('app')
export function getTrustedDeviceToken() {
  return localStorage.getItem('trusted_device')
}
@Component({
  components: { ForgotPasswordCard },
  directives: {
    GoogleSignInButton
  }
})
export default class Login extends Vue {
  @AppModule.Getter
  public _isLoading!: () => boolean

  @AppModule.Getter
  public _getUserInsurances!: () => string

  public show2FA = false
  public showForgotPassword = false
  public forgotStep: 'email' | 'otp' | 'password' = 'email'
  public form = {} as LoginVM
  public hint = null
  public externalToken: string | null = null
  public externalAccount: string | null = null
  // public externalLogin = false
  public clientId =
    '226859534392-6ovdtlta692dss182f5simanng0t5cur.apps.googleusercontent.com'
  // // userName: '12345678900', password: 'RmT@1DGBL0'
  public path = ''
  // @AppModule.Action('fetchNotifications') fetchNotifications!: () => Promise<
  //   void
  // >

  goBack() {
    this.show2FA = false
    this.showForgotPassword = false
    this.forgotStep = 'email'
    this.form.code = ''
  }

  get loginColClass(): string {
    if (this.showForgotPassword && this.forgotStep === 'password') {
      return 'col-sm-11 col-md-9 col-lg-8 mx-auto text-center'
    }
    return 'col-sm-9 col-md-7 col-lg-5 mx-auto text-center'
  }

  async SignInWithMicrosoft() {
    try {
      const authResponse = await this.$msal.loginPopup()
      const token = authResponse.account.username
      this.externalToken = token
      this.externalAccount = 'Microsoft'
      const response = {
        token,
        account: 'Microsoft'
      } as ExternalResponse
      const externalLoginUser = await loginWithGoogle(response)

      await this._login(externalLoginUser, true)
    } catch (err) {
      console.error(err)
    }
  }
  async getToken() {
    try {
      const authResponse = await this.$msal.acquireToken({
        scopes: ['user.read']
      })

      return authResponse.accessToken
    } catch (err) {
      console.error(err)
      return null
    }
  }

  async OnGoogleAuthSuccess(user) {
    const token =
      typeof user === 'string'
        ? user
        : user?.getAuthResponse?.()?.id_token || user
    this.externalToken = token
    this.externalAccount = 'Google'
    const response = { token, account: 'Google' } as ExternalResponse
    try {
      const externalLoginUser = await loginWithGoogle(response)
      await this._login(externalLoginUser, true)
    } catch (err) {
      console.error(err)
      this.$bvToast.toast('Google sign-in failed. Try again.', {
        title: 'Sign in',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-bottom-right'
      })
    }
  }
  OnGoogleAuthFail(user) {
    console.log(user)
  }

  async _login(
    externalLoginUser: AxiosResponse<LoginResultSessionVM> = null,
    externalLogin = false
  ) {
    let response = null

    // Validate OTP/2FA fields when visible
    if (this.show2FA) {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) return
    }

    try {
      if (this.show2FA && this.externalToken && this.externalAccount) {
        response = await loginWithGoogle({
          token: this.externalToken,
          account: this.externalAccount,
          code: this.form.code,
          trustBrowser: !!this.form.trustBrowser
        })
      } else if (!externalLogin) {
        response = await login({
          ...this.form,
          trustBrowser: !!this.form.trustBrowser,
          trustedDeviceToken: getTrustedDeviceToken()
        })
      } else {
        response = externalLoginUser
      }
    } catch (err) {
      console.error(err)
      return
    }

    const data = response?.data || {}
    const is2FA = data.is2FA === true || data.Is2FA === true
    const requirePasswordChange =
      data.requirePasswordChange === true || data.RequirePasswordChange === true
    const token = data.token || data.Token

    if (is2FA) {
      this.show2FA = true
      this.hint = data.hint || data.Hint
      return
    }

    if (requirePasswordChange) {
      if (token) {
        localStorage.setItem('token', token)
        localStorage.setItem('currentUser', JSON.stringify(data))
      }
      this.$router.push({ name: 'ChangePassword' })
      return
    }

    if (token) {
      const user = data
      const trusted = data.trustedDeviceToken || data.TrustedDeviceToken
      if (trusted) {
        localStorage.setItem('trusted_device', trusted)
      }

      localStorage.setItem('currentUser', JSON.stringify(user))
      localStorage.setItem('token', token)
      localStorage.setItem(
        'needsADoctor',
        data.needsADoctor || data.NeedsADoctor ? 'true' : 'false'
      )

      if (data.policyAccepted === false || data.PolicyAccepted === false) {
        this.$router.push('/completeProfile')
      } else {
        this.$router.push({ name: 'PatientsView' })
      }

      if (this._getUserInsurances !== null) {
        return
      }

      switch (user.role || user.Role) {
        case Role.Insurance:
          await this.getUserInsurances(user.rmtUserId || user.RmtUserId)
          break
        case Role.InsuranceStaff:
          await this.getUserInsurances(user.rmtUserId || user.RmtUserId)
          break
        case Role.Doctor:
          await this._getDoctorInsurances(user.rmtUserId || user.RmtUserId)
          break
        case Role.DoctorStaff:
          await this._getDoctorInsurances(
            user.doctorHeadId || user.DoctorHeadId
          )
          break
      }
    } else {
      this.$bvToast.toast('Sign-in did not return a session. Try again.', {
        title: 'Sign in',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-bottom-right'
      })
    }
  }
  async _getDoctorInsurances(rmtuserId: number) {
    await getDoctorInsurances(rmtuserId).then(response => {
      this.$store.dispatch('app/addUserInsurance', response)
    })
  }
  async getUserInsurances(rmtuserId: number) {
    await getUserInsurances(rmtuserId).then(response => {
      this.$store.dispatch('app/addUserInsurance', response)
    })
  }
}
